export const extractUtmParams = (
  input:
    | URLSearchParams
    | { [key: string]: string | string[] | undefined }
    | undefined
): { utmObject: Record<string, string>; utmString: string } => {
  const utmObject: Record<string, string> = {};
  const utmEntries: string[] = [];

  if (input) {
    const iterateTarget =
      input instanceof URLSearchParams ? input : Object.entries(input);

    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of iterateTarget) {
      if (key.startsWith('utm_')) {
        if (!Array.isArray(value)) {
          if (typeof value === 'string') {
            utmObject[key] = value;
          }
          utmEntries.push(`${key}=${utmObject[key]}`);
        }
      }
    }
  }

  const utmString = utmEntries.join('&');

  return {
    utmObject,
    utmString,
  };
};
